import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddProfilePhotoMutationVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
  objects?: Types.InputMaybe<Types.Users_Set_Input>;
}>;


export type AddProfilePhotoMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: string, profile_photo?: string | null } | null };


export const AddProfilePhotoDocument = gql`
    mutation addProfilePhoto($userId: String!, $objects: users_set_input) {
  update_users_by_pk(pk_columns: {id: $userId}, _set: $objects) {
    id
    profile_photo
  }
}
    `;
export type AddProfilePhotoMutationFn = Apollo.MutationFunction<AddProfilePhotoMutation, AddProfilePhotoMutationVariables>;

/**
 * __useAddProfilePhotoMutation__
 *
 * To run a mutation, you first call `useAddProfilePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProfilePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProfilePhotoMutation, { data, loading, error }] = useAddProfilePhotoMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddProfilePhotoMutation(baseOptions?: Apollo.MutationHookOptions<AddProfilePhotoMutation, AddProfilePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProfilePhotoMutation, AddProfilePhotoMutationVariables>(AddProfilePhotoDocument, options);
      }
export type AddProfilePhotoMutationHookResult = ReturnType<typeof useAddProfilePhotoMutation>;
export type AddProfilePhotoMutationResult = Apollo.MutationResult<AddProfilePhotoMutation>;
export type AddProfilePhotoMutationOptions = Apollo.BaseMutationOptions<AddProfilePhotoMutation, AddProfilePhotoMutationVariables>;